import { fetchBiography } from '@/services/sheets'

export default {
    namespaced: true,

    state: () => ({
        items: [],
        loading: false,
        loaded: false,
    }),

    getters: {
        all: state => state.items,
        hasItems: state => state.items.length > 0,
    },

    mutations: {
        SET_ITEMS(state, items) { state.items = items },
        SET_LOADING(state, val) { state.loading = val },
        SET_LOADED(state, val) { state.loaded = val },
    },

    actions: {
        async fetch({ commit, state }) {
            if (state.loaded) return
            commit('SET_LOADING', true)
            try {
                const data = await fetchBiography()
                commit('SET_ITEMS', data)
                commit('SET_LOADED', true)
            } catch (e) {
                console.error('[Store:biography]', e)
            } finally {
                commit('SET_LOADING', false)
            }
        }
    }
}
